import { OrchestratorRunSettings } from "../../../services/api/__generated__/backend_gateway-types";

export const runSettingsAndStepToId = (
  runSettings: OrchestratorRunSettings,
  stepId: string
): string =>
  `${runSettings.inputId}${runSettings.workflowId}${runSettings.variablesId}${runSettings.runAttemptId}${stepId}`;
